module.exports = __webpack_public_path__ + "portal/assets/img/logo.799d004f.svg";